export const ANALYTICS_CONSENT_STORAGE_KEY = 'aa_analytics_consent_v1'
export const OPEN_ANALYTICS_CONSENT_EVENT = 'aa:open-analytics-consent'

export type AnalyticsConsent = 'granted' | 'denied'

type GoogleConsentState = {
  analytics_storage: AnalyticsConsent
  ad_storage: 'denied'
  ad_user_data: 'denied'
  ad_personalization: 'denied'
}

export function parseAnalyticsConsent(value: string | null): AnalyticsConsent | null {
  return value === 'granted' || value === 'denied' ? value : null
}

export function getGoogleConsentState(consent: AnalyticsConsent | null): GoogleConsentState {
  return {
    analytics_storage: consent === 'granted' ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  }
}

export function getGoogleTagManagerConsentBootstrap(containerId: string): string {
  const storageKey = JSON.stringify(ANALYTICS_CONSENT_STORAGE_KEY)
  const gtmContainerId = JSON.stringify(containerId)
  const grantedConsent = JSON.stringify(getGoogleConsentState('granted'))
  const deniedConsent = JSON.stringify(getGoogleConsentState('denied'))

  return `(function(w,d,i){
w.dataLayer=w.dataLayer||[];
w.gtag=w.gtag||function(){w.dataLayer.push(arguments);};
var consent=null;
try{consent=w.localStorage.getItem(${storageKey});}catch(e){}
var analyticsGranted=consent==='granted';
w.gtag('consent','default',analyticsGranted?${grantedConsent}:${deniedConsent});
w.__aaLoadGoogleTagManager=w.__aaLoadGoogleTagManager||function(){
  if(w.__aaGoogleTagManagerLoaded||/^\\/auth\\/new-password\\/?$|^\\/bezplatna-konsultacja\\/[^/]+\\/odwolaj\\/?$/.test(w.location.pathname))return;
  w.__aaGoogleTagManagerLoaded=true;
  w.dataLayer.push({'gtm.start':new Date().getTime(),event:'gtm.js'});
  var first=d.getElementsByTagName('script')[0],script=d.createElement('script');
  script.async=true;
  script.src='https://www.googletagmanager.com/gtm.js?id='+i;
  first.parentNode.insertBefore(script,first);
};
if(analyticsGranted)w.__aaLoadGoogleTagManager();
})(window,document,${gtmContainerId});`
}
